export const SEARCH_FORM_SUBMIT = 'COORDINATOR.ACTIVITIES.SEARCH_FORM_SUBMIT';
export const SORT_CHANGE = 'COORDINATOR.ACTIVITIES.SORT_CHANGE';
export const PAGE_CHANGE = 'COORDINATOR.ACTIVITIES.PAGE_CHANGE';
export const FETCH_LIST = 'COORDINATOR.ACTIVITIES.FETCH_LIST';
export const FETCH_ONE = 'COORDINATOR.ACTIVITY.FETCH_ONE';
export const CLEAR_ONE = 'COORDINATOR.ACTIVITY.CLEAR_ONE';
